import React from 'react';

import { Flex } from '@chakra-ui/react';

import { Seperator } from 'components/Seperator';
import { translations } from 'new/form/common/types';
import { withAssociatedPeopleEditMode } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/components/associatedPeopleMode/withAssociatedPeopleEditMode';
import { PortalLegalRepresentative } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/components/legalRepresentatives/fields';
import ButtonComponent from 'theme/components/Button';
import AddIcon from 'theme/components/Icon/AddIcon';
import { useTranslations } from 'utils/hooks/useTranslations';

import CbBankAddLegalRepresentativeModal from './CbBankAddLegalRepresentativeModal';
import CbBankDeleteLegalRepresentativeModal from './CbBankDeleteLegalRepresentativeModal';
import CbBankEditLegalRepresentativeModal from './CbBankEditLegalRepresentativeModal';
import { CbBankLegalRepresentativeAccordion } from './CbBankLegalRepresentativeAccordion';
import { useEditAssociatedPeople } from '../../../hooks/useEditAssociatedPeople';

type Props = {
  legalRepresentatives: Array<PortalLegalRepresentative>;
};

export const CbBankLegalRepresentatives = ({ legalRepresentatives }: Props) => {
  const t = useTranslations();
  const { heading, noLegalRepresentatives } =
    translations.pages.companiesDetails.associatedPerson.new.legalRepresentatives;

  const {
    isAddModalOpen,
    onAddModalClose,
    onAddModalOpen,
    isDeleteModalOpen,
    onDeleteModalClose,
    onDeleteModalOpen,
    isEditModalOpen,
    onEditModalClose,
    onEditModalOpen,
    selectedPerson: selectedLegalRep,
    setSelectedPerson: setSelectedLegalRep,
  } = useEditAssociatedPeople<PortalLegalRepresentative>();

  return (
    <>
      <Seperator
        divider
        title={`${t(heading)} (${legalRepresentatives.length})`}
        action={<EditModeActions onAddModalOpen={onAddModalOpen} />}
      >
        {legalRepresentatives.length > 0 ? (
          legalRepresentatives.map((legalRepresentative) => {
            return (
              <CbBankLegalRepresentativeAccordion
                key={legalRepresentative.id}
                legalRepresentative={legalRepresentative}
                setSelectedLegalRep={setSelectedLegalRep}
                onEditModalOpen={onEditModalOpen}
                onDeleteModalOpen={onDeleteModalOpen}
                index={legalRepresentatives.indexOf(legalRepresentative)}
              />
            );
          })
        ) : (
          <Flex justifyContent={'center'} w={'full'} p={12} color="text.tertiary">
            {t(noLegalRepresentatives)}
          </Flex>
        )}
      </Seperator>
      <CbBankAddLegalRepresentativeModal isOpen={isAddModalOpen} onClose={onAddModalClose} />
      <CbBankEditLegalRepresentativeModal
        isOpen={isEditModalOpen}
        onClose={onEditModalClose}
        initialValues={selectedLegalRep}
      />
      <CbBankDeleteLegalRepresentativeModal
        isOpen={isDeleteModalOpen}
        onClose={onDeleteModalClose}
        legalRep={selectedLegalRep}
      />
    </>
  );
};

type ActionProps = {
  onAddModalOpen: () => void;
};

const Actions = ({ onAddModalOpen }: ActionProps) => {
  const t = useTranslations();
  const { actions } = translations.pages.companiesDetails.associatedPerson.new.legalRepresentatives;
  return (
    <ButtonComponent
      variant={'link'}
      onClick={(event) => {
        onAddModalOpen();
        event.preventDefault();
      }}
      leftIcon={<AddIcon boxSize={6} display={'block'} />}
      testId="addLegalRepresentativeButton"
    >
      {t(actions.add.caption)}
    </ButtonComponent>
  );
};

const EditModeActions = withAssociatedPeopleEditMode(Actions);
